
export enum CisRequestApprovalStatusCd {
	APPROVED = 'Approved',
	BLANK = 'Blank',
	PENDING = 'Pending',
	REJECTED = 'Rejected'}

